import { useEffect, useRef } from 'react';

const typing = (e) => { const t = e.target; const tag = (t?.tagName || '').toLowerCase(); return t?.isContentEditable || tag === 'input' || tag === 'textarea' || tag === 'select'; };

/** Gmail/Outlook-style keys. handlers: { next, prev, open, back, select, archive, trash, star, unread, compose, search, label, move, help, goto(folder), thread(key, ev) } */
export const useMailShortcuts = (handlers, enabled = true) => {
  const h = useRef(handlers);
  h.current = handlers;
  const pendingG = useRef(false);
  useEffect(() => {
    if (!enabled) return undefined;
    const onKey = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (typing(e)) { if (e.key === 'Escape') e.target.blur(); return; }
      if (document.querySelector('[data-testid="mail-composer"]')) return;
      const k = e.key;
      if (pendingG.current) {
        pendingG.current = false;
        const f = { i: 'inbox', s: 'starred', t: 'sent', d: 'drafts', a: 'all' }[k];
        if (f) { e.preventDefault(); h.current.goto?.(f); }
        return;
      }
      if (k === 'g') { pendingG.current = true; setTimeout(() => { pendingG.current = false; }, 900); return; }
      if (h.current.thread?.(k, e)) return;
      const map = {
        j: 'next', ArrowDown: 'next', k: 'prev', ArrowUp: 'prev', Enter: 'open', o: 'open', u: 'back', Escape: 'back', x: 'select',
        e: 'archive', '#': 'trash', s: 'star', U: 'unread', c: 'compose', '/': 'search', l: 'label', v: 'move', '?': 'help',
      };
      const fn = map[k];
      if (fn && h.current[fn]) { e.preventDefault(); h.current[fn](); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled]);
};
